import { parseServerDate } from "src/utils/dateTime";

export interface StatementEvent {
	id: number;
	target_type: "statement";
	target_id: number;
	action: string;
	created_at: string;
	user_id?: number | null;
	user_name?: string | null;
	data?: unknown;
}

const isRecord = (value: unknown): value is Record<string, unknown> => Boolean(value) && typeof value === "object" && !Array.isArray(value);

/** Reject an ignored/unsupported target filter instead of showing another object's audit trail. */
export const readStatementEvents = (value: unknown, statementId: number): StatementEvent[] | null => {
	if (!Array.isArray(value)) return null;
	if (value.some(item => !isRecord(item) || item.target_type !== "statement" || Number(item.target_id) !== statementId
		|| !Number.isSafeInteger(Number(item.id)) || Number(item.id) <= 0 || typeof item.action !== "string"
		|| typeof item.created_at !== "string" || !parseServerDate(item.created_at))) return null;
	return value.map(item => ({ ...item, id: Number(item.id), target_id: statementId } as StatementEvent))
		.sort((a, b) => (parseServerDate(b.created_at)?.getTime() ?? 0) - (parseServerDate(a.created_at)?.getTime() ?? 0) || b.id - a.id);
};

export const statementEventPayload = (value: unknown): Record<string, unknown> | null => {
	let parsed = value;
	if (typeof parsed === "string") {
		const text = parsed;
		try { parsed = JSON.parse(text); } catch { return text.trim() ? { details: text } : null; }
	}
	return isRecord(parsed) && Object.keys(parsed).length ? parsed : null;
};
